import classNames from 'classnames';
import { Divider as MuiDivider } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

const styles = () => ({
  root: {},
});

const Divider = (props) => {
  const { isVisible = true, gap = '10px 0px 15px 0px', classes, ...rest } = props;
  const { root } = classes;

  const rootClassName = classNames(root, {});

  return isVisible ? (
    <MuiDivider classes={{ root: rootClassName }} style={{ margin: gap }} {...rest} />
  ) : null;
};

const StyledDivider = withStyles(styles)(Divider);

export { StyledDivider as Divider };
